<div class="container-fluid my-container">
    <header>
        <app-header></app-header> 
    </header>
    
    <router-outlet></router-outlet>
</div>

<footer class="footer">
    <app-footer></app-footer>
</footer>   


